<div [class]="skinName">
<!-- for stripe   -->
 @if (paymentGateway === 'stripe') {

   <ngx-stripe-card-group [formGroup]="stripeTest" [elementsOptions]="elementsOptions">
     <div class="align-input" [ngClass]="{ 'has-error' : stripeTest.controls.name.invalid && !stripeTest.controls.name.pristine }">
       @if (stripeTest.controls.name.untouched || stripeTest.controls.name.valid) {
         <p class="input-placeholder">{{ configService.localeKeys?.cardholder_name }}
         </p>
       }
       @if (stripeTest.controls.name.invalid && stripeTest.controls.name.touched && stripeTest.get('name').hasError('required')
         ) {
         <p class="input-placeholder error-block">{{ configService.localeKeys?.sign_up_desc_ur_nam_req_def}}</p>
       }
       @if (stripeTest.controls.name.invalid && stripeTest.controls.name.touched && !stripeTest.get('name').hasError('required')
         ) {
         <p class="input-placeholder error-block">{{ configService.localeKeys?.['common_keys.desc_ur_name.text']}}</p>
       }
       <input formControlName="name" class="input-box form-control" placeholder="{{ configService.localeKeys?.kws_kw_name_def}}" />
     </div>
     <div class="align-input" [ngClass]="{ 'has-error' : stripeTest.controls.email.invalid && !stripeTest.controls.email.pristine }">
       @if (stripeTest.controls.email.untouched || stripeTest.controls.email.valid) {
         <p class="input-placeholder">{{ configService.localeKeys?.['account.enter_email.text'] }}
         </p>
       }
       @if (stripeTest.controls.email.invalid && stripeTest.controls.email.touched && stripeTest.get('email').hasError('required')
         ) {
         <p class="input-placeholder error-block">{{ configService.localeKeys?.['login.email_is_required.text']}}</p>
       }
       @if (stripeTest.controls.email.invalid && stripeTest.controls.email.touched && stripeTest.get('email').hasError('pattern')
         ) {
         <p class="input-placeholder error-block">{{ configService.localeKeys?.['common_keys.invalid_email.text']}}</p>
       }
       <input formControlName="email" class="input-box form-control" placeholder="{{ configService.localeKeys?.['login.your_email.text']}}" [readonly]="true" />
     </div>
     <div>
       @if (!(cardNumberValidation?.error?.message || cardNumberValidation?.error?.code)) {
         <p class="input-placeholder stripe-input">
         {{ configService.localeKeys?.card_name }}</p>
       }
       @if(cardNumberValidation?.error?.message && cardNumberValidation?.error?.code == 'incomplete_number'){
         <p  class="input-placeholder stripe-input error-block">
           {{(configService.localeKeys?.signup_err_incomplete_card_num) ? configService.localeKeys?.signup_err_incomplete_card_num : cardNumberValidation?.error?.message}}</p>
       }
       @if(cardNumberValidation?.error?.message && cardNumberValidation?.error?.code == 'invalid_number'){
         <p class="input-placeholder stripe-input error-block">
           {{ (configService.localeKeys?.signup_err_invalid_card_num) ? configService.localeKeys?.signup_err_invalid_card_num : cardNumberValidation?.error?.message}}</p>
       }
       @if(cardNumberValidation?.error?.message && (cardNumberValidation?.error?.code != 'invalid_number' && cardNumberValidation?.error?.code != 'incomplete_number')){
         <p  class="input-placeholder stripe-input error-block">
           {{(configService.localeKeys?.signup_err_incomplete_card_num) ? configService.localeKeys?.signup_err_incomplete_card_num : cardNumberValidation?.error?.message}}</p>
       }
       <ngx-stripe-card-number (change)="errorValidation($event)" [options]="cardOptions">
       </ngx-stripe-card-number>
     </div>
     <div class="card-cred">
       <div class="w-45">
         @if (!(cardExpiryValidation?.error?.message || cardExpiryValidation?.error?.code)) {
           <p class="input-placeholder stripe-input">
           {{ configService.localeKeys?.['account.expiry_date.text'] }}</p>
         }
         @if(cardExpiryValidation?.error?.message && cardExpiryValidation?.error?.code == 'incomplete_expiry'){
           <p class="input-placeholder stripe-input error-block">
             {{(configService.localeKeys?.signup_err_incomplete_exp_date) ? configService.localeKeys?.signup_err_incomplete_exp_date  : cardExpiryValidation?.error?.message}}</p>
         }
         @if(cardExpiryValidation?.error?.message && cardExpiryValidation?.error?.code == 'invalid_expiry_year_past'){
           <p class="input-placeholder stripe-input error-block">
             {{(configService.localeKeys?.signup_err_card_expired_num) ? configService.localeKeys?.signup_err_card_expired_num : cardExpiryValidation?.error?.message}}</p> 
         }
         @if(cardExpiryValidation?.error?.message && cardExpiryValidation?.error?.code == 'invalid_expiry_year'){
           <p  class="input-placeholder stripe-input error-block">
             {{(configService.localeKeys?.signup_err_exp_invalid_num) ? configService.localeKeys?.signup_err_exp_invalid_num : cardExpiryValidation?.error?.message}}</p> 
         }
         @if(cardExpiryValidation?.error?.message && (cardExpiryValidation?.error?.code != 'incomplete_expiry' && cardExpiryValidation?.error?.code != 'invalid_expiry_year_past' && cardExpiryValidation?.error?.code != 'invalid_expiry_year'   )){
           <p class="input-placeholder stripe-input error-block">
             {{(configService.localeKeys?.signup_err_incomplete_exp_date) ? configService.localeKeys?.signup_err_incomplete_exp_date  : cardExpiryValidation?.error?.message}}</p>
         }
       
       </div>
       <div class="w-45">
         @if (!(cardCvvValidation?.error?.message || cardCvvValidation?.error?.code)) {
           <p class="input-placeholder stripe-input">
           {{ configService.localeKeys?.security_code }}</p>
         }
         @if (cardCvvValidation?.error?.message) {
           <p class="input-placeholder stripe-input error-block">
           {{(configService.localeKeys?.signup_err_incomplete_security_code) ? configService.localeKeys?.signup_err_incomplete_security_code : cardCvvValidation?.error?.message}}</p>
         }
       </div>
 
     </div>
     <div class="card-cred">
       <div class="w-45">
         <ngx-stripe-card-expiry (change)="errorValidation($event)" [options]="cardOptions">
         </ngx-stripe-card-expiry>
       </div>
       <div class="w-45 cvc_value">
         <ngx-stripe-card-cvc (change)="errorValidation($event)" [options]="cardOptions">
         </ngx-stripe-card-cvc>
         <span class = "cvvtooltip"><img src="/branding/theme/assets/static_assets/ic-info-on-lbg.svg">
           <span class = "cvvtext"> {{ configService.localeKeys?.acc_dtl_cvv_tooltip_desc || "The three digit CVV number is displayed on the back of the card,to the right of the signature."}} </span>
         </span>
       </div>
     </div>
     <button type="submit" [disabled]="paymentBtnDisabled" id="pay-btn" class="btn" (click)="payment($event)">{{buttonValue}}</button>
   </ngx-stripe-card-group>
   @if (!fingerPrintData?.fingerprint_checked && freeTrialDays > 0) {
     <div id="free-time">
       {{ configService.localeKeys?.payment_charge_date }} {{nextBillingDate}}
     </div>
   }
   <app-stripe-info></app-stripe-info>
   <!-- fingerprint popup - please check for the same popup in stripe component -->
   <div id="fingerprint-confirm-modal" uk-modal>
     <div class="uk-modal-dialog uk-modal-body modal-popup-body">
       <div class="modal-popup-logo"></div>
       <div class="modal-popup-title uk-modal-title">{{configService.localeKeys?.pay_stripe_finger_pop_up_title}}</div>
       <p class="modal-popup-description">{{configService.localeKeys?.pay_stripe_finger_pop_up_desc}}</p>
       <div class="uk-modal-footer uk-text-right">
         <button class="uk-button modal-popup-ok" type="button" (click)="fingerPrintProceed('#fingerprint-confirm-modal')">{{configService.localeKeys?.pay_stripe_finger_pop_up_btn_ok}}</button>
         <button class="uk-button modal-popup-cancel" type="button" (click)="fingerPrintTryAgain('#fingerprint-confirm-modal')">{{configService.localeKeys?.pay_stripe_finger_pop_up_btn_cancel}}</button>
       </div>
     </div>
   </div>
 }
 @else if (paymentGateway === 'adyen') {
   <!-- for adyen -->
   <div id="adyen-card-container"></div>
 }

</div>